import React from "react";
import { Form, Input } from "antd";

import { OZInputType } from "helpers/types";

const OZInput = ({
    disabled = false,
    icon,
    label,
    name,
    placeholder,
    rules,
    size = "large",
    type = "text",
}: OZInputType) => {
    return (
        <Form.Item hasFeedback label={label} name={name} rules={rules}>
            <Input
                disabled={disabled}
                prefix={icon}
                placeholder={placeholder}
                size={size}
                type={type}
            />
        </Form.Item>
    );
};

export default OZInput;
